import api from 'src/services/api';
import * as utils from './apiUtils';
import type {
  TagIndexParams,
  TagCreateParams,
} from 'src/models/apis/tag/tagRequest';
import {
  type TagIndexResponse,
  type TagResponse,
  toTag,
} from 'src/models/apis/tag/tagResponse';
import type { Tag } from 'src/models/tag';
import type {
  AdminTagCreateParams,
  AdminTagUpdateParams,
  AdminTagNameIdentifyParams,
} from 'src/models/apis/tag/adminTagRequest';
import {
  type AdminTagIndexResponse,
  type AdminTagResponse,
  toAdminTag,
  toAdminTagIndexItem,
} from 'src/models/apis/tag/adminTagResponse';
import type { AdminTagIndexItem, AdminTag } from 'src/models/tag';

export default {
  async index(): Promise<Tag[]> {
    const response = await api.get<TagIndexResponse>(utils.getApiUrl('/tags'));
    return response.data.map(toTag);
  },
  async create(params: TagCreateParams): Promise<Tag> {
    const response = await api.post<TagResponse>(utils.getApiUrl('/tags'), params);
    return toTag(response.data);
  },
  async update(id: number, params: TagCreateParams): Promise<Tag> {
    const response = await api.put<TagResponse>(utils.getApiUrl(`/tags/${id}`), params);
    return toTag(response.data);
  },
  async destroy(id: number): Promise<Tag> {
    const response = await api.delete<TagResponse>(utils.getApiUrl(`/tags/${id}`));
    return toTag(response.data);
  },
  async adminIndex(params: TagIndexParams): Promise<AdminTagIndexItem[]> {
    const response = await api.get<AdminTagIndexResponse>(utils.getApiUrl('/admin/tags'), {
      params,
    });
    return response.data.map(toAdminTagIndexItem);
  },
  async adminCreate(params: AdminTagCreateParams): Promise<AdminTag> {
    const response = await api.post<AdminTagResponse>(utils.getApiUrl('/admin/tags'), params);
    return toAdminTag(response.data);
  },
  async adminUpdate(id: number, params: AdminTagUpdateParams): Promise<AdminTag> {
    const response = await api.put<AdminTagResponse>(utils.getApiUrl(`/admin/tags/${id}`), params);
    return toAdminTag(response.data);
  },
  async adminDestroy(id: number): Promise<AdminTag> {
    const response = await api.delete<AdminTagResponse>(utils.getApiUrl(`/admin/tags/${id}`));
    return toAdminTag(response.data);
  },
  async adminNameIdentify(params: AdminTagNameIdentifyParams): Promise<AdminTag> {
    const response = await api.post<AdminTagResponse>(utils.getApiUrl('/admin/tags/name_identify'), params);
    return toAdminTag(response.data);
  },
};
